<template>
<div class="productPic">
    <div class="productHeader">
        <!-- <h2 class="">
                <span v-html="tlNum"></span>
                <span v-html="proTitle"></span>
            </h2> -->
        <!-- <div class="productFlag">
                <div class="flag" v-if="labelList"><span v-for="(item,k) in labelList" :key="k">{{item.name}}</span></div>
            </div> -->
        <div class="productTips" >
                <span class="showBig"></span>
                <span v-if="isMem==1&&menFlag&& isHd>0"  class="vipDt" @click="viptuFu"><img class="gaoqing_img" src="../../../../assets/imgs/gaoqing_tu_icon.png" alt="">超清无损大图</span>
            </div>
        <div class="vipBtn" v-if="(isLogin==0||isMem==0)&&menFlag"  @click="viptuFu">
            <img src="@/assets/imgs/vip_icon.png" alt=""> 开通藏家会员，查看高清无损大图
            <!-- <span class="showBig">图片中的放大镜，支持鼠标滚轮缩放区域大小</span>
                <span v-if="ifHd!=0" class="vipDt" @click="viptuFu"><img class="gaoqing_img" src="../../../../assets/imgs/gaoqing_tu.png" alt="">超清无损大图</span> -->
        </div>
        <div class="swiperDetail" v-if="bigPicArray.length && bigPicArray.length > 1" v-show="ifShowArray">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-wrapper-box" :style="'width:'+62*bigPicArray.length+'px;margin-left:'+leftShu*62+'px;'">
                        <div :class="i==tuIndex?'swiper-slide swiper-slide-active':'swiper-slide'" v-for="(item, i) in bigPicArray" :key="i" @click="xtu(i)">
                            <img :src="item" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-button-next" @click="xtuNext()"></div>
            <div class="swiper-button-prev" @click="xtuPrev()"></div>
        </div>
    </div>
    <div class="productBigShow">
        <div class="blurImgBox">
            <img :src="bigPicArray[tuIndex]">
        </div>
        <div class="artronIcon">

            </div>
        <div class="productBigBox" v-if="bigPicArray.length">
            <div :style="(isLogin==0||isMem==0)?'cursor: zoom-in;':''" class="picCell picCellCom" id="smallOuter" @mouseenter="circleShow($event)" @mouseleave="circleHide($event)" @mousemove="moveCircle($event)">
                <img :src="bigPicArray[tuIndex]" id="smallPic" :data-width="picWidth[tuIndex]" :data-height="picHeight[tuIndex]" v-if="bigPicArray[tuIndex] && search2JSON(bigPicArray[tuIndex]) && search2JSON(bigPicArray[tuIndex]).src!=='/'">
                <div class="noBigPic" v-else>暂无图像</div>
                <div class="circle" :class="{'showCircle':showCircle}" id="circleOuter" :style="'background-image: url('+bigPicArray[tuIndex]+')'" @mousewheel="wheelCircel" @contextmenu.prevent="stopEvent($event)" @dragstart.prevent="stopEvent($event)" @mousewheel.prevent="stopEvent($event)"></div>
                <div class="hdTips" id="bigImageMessage" v-if="bigMessageShow && isHd>0"><a href="javascript:void(0)" class="close" @click="closeTips"></a>看图效果不理想？进入“<a href="javascript:void(0)" @click="viptuFu">大图精览</a>”看图模式
                </div>
            </div>
            <!--                <span @click="viptuFu" v-if="isHd>0">雅昌会员精览高清大图</span>-->
        </div>
    </div>
</div>
</template>

<script>
// import 'social-share.js/src/js/social-share'
import {
    getMemType
} from "@/api/auction";
import {
    sendScData
} from "@/utils/buriedPoint";

export default {
    props: {
        proTitle: {
            type: String
        },
        tlNum: {
            type: String
        },
        labelList: {
            type: Array
        },
        bigPicArray: {
            type: Array
        },
        picWidth: {
            type: Array
        },
        picHeight: {
            type: Array
        },
        ppinData: {
            type: Object,
        },
        isLogin: {
            type: Number
        },
        isHd: {
            type: Number
        },
        scJSON: {
            type: Object,
            default () {
                return {
                    auction_items_id: '',
                    auction_items_name: ''
                }
            }
        }
    },
    name: "productHeader",
    computed: {
        detailData() {
            return this.ppinData || {}
        },
        ifHd() {
            return this.isHd || 0
        }
    },
    data() {
        return {
            showCircle: false,
            bigMessageShow: false,
            xianShu: 5, //显示小图的数量
            tuIndex: 0, //图片下标
            leftShu: 0, //向左移动的数量
            isMem: 0,
            ifShowArray: true,
            timer: 0,
            menFlag: false,
        }
    },
    mounted() {
        /* setTimeout(function (){
            new Swiper('.swiper-container', {
                slidesPerView: 5,
                spaceBetween: 4,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        },500) */
        /* socialShare('.social-share',{
            sites               : ['weibo'], // 启用的站点
        })
        socialShare('.sharePop',{
            sites               : ['qq','wechat','tencent','douban','qzone','linkedin','diandian','facebook','twitter','google'], // 启用的站点
            disabled            : [], // 禁用的站点
            wechatQrcodeTitle   : "微信扫一扫：分享", // 微信二维码提示文字
            wechatQrcodeHelper  : '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>',
        }) */
        this.getMemType()
        this.search2JSON('https://thumb.artron.net/Img/image?src=/')
    },
    methods: {
        getMemType() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember
                    this.menFlag = true
                    
                }
            })
        },
        // 点击会员精览高清大图
        viptuFu() {

            if (this.$route.query.from) {
                return false
            }
            if(this.isLogin==0){//未登录
                window.location.href = '//passport.artron.net/login?appId=1&redirect='+encodeURIComponent(window.location.href)
            }else{
                if(this.isMem==0){//已登录，不是会员
                    this.$confirm('<div style="line-height:24px;"><div style="font-size: 18px;">尊敬的用户：</div><div style="font-size: 16px;">开通藏家会员，51万余张拍品高清大图会员免费无限次精览，APP/PC跨屏浏览无障碍</div><div style="font-size: 16px;">*开通会员后刷新该页面开启大图精览</div></div>', '开通会员', {
                        confirmButtonText: '开通会员',
                        cancelButtonText: '关闭',
                        customClass: 'vipBox',
                        dangerouslyUseHTMLString: true
                    }).then(() => {
                       // window.open('https://member.artron.net/service/item/collectbuy/?business_id=' + business_id + '&business_type=' + business_type + '&package_id=' + package_id + '&product_sku=' + product_sku)
                        window.open('https://member.artronvip.com/service/item/collectbuy/?business_id=50001&business_type=4&package_id=40&product_sku=289')
                    });
                } else if (this.isMem == 2) { //已登录，是会员
                    this.$confirm('<div style="line-height:24px;"><div style="font-size: 18px;">尊敬的用户：</div><div style="font-size: 16px;">您的会员已过期，请先续费～</div></div>', {
                        confirmButtonText: '开通会员',
                        cancelButtonText: '关闭',
                        customClass: 'vipBox',
                        dangerouslyUseHTMLString: true
                    }).then(() => {
                        // window.open('https://member.artron.net/service/item/collectbuy/?business_id=' + business_id + '&business_type=' + business_type + '&package_id=' + package_id + '&product_sku=' + product_sku)
                         window.open('https://member.artronvip.com/service/item/collectbuy/?business_id=50001&business_type=4&package_id=40&product_sku=289')
                    });
                } else { //已登录，是会员
                    window.open('https://tulu.artron.net/wap/NewHdImage/bigpic/' + this.$route.params.id)
                }
            }
            sendScData('auctionButtonClick', {
                auction_items_id: this.scJSON.auction_items_id,
                auction_items_name: this.scJSON.auction.auction_items_name,
                button_name: '雅昌会员精览高清大图'
            })
        },
        moveCircle(event) {
            if ((this.isLogin==0||this.isMem==0)) {
                return false
            }
            if (!document.getElementById('smallPic')) {
                return false
            }
            var x = event.pageX || event.clientX,
                y = event.pageY || event.clientY,
                oCircle = document.getElementById('circleOuter'),
                circleWidth = oCircle.clientWidth || 0,
                bannerLeft = document.querySelector('.productBigShow').offsetLeft,
                bannerTop = document.querySelector('.productBigShow').offsetTop,
                smallPicEle = document.getElementById('smallPic'),
                smallPicLeft = smallPicEle.offsetLeft || 0,
                smallPicTop = smallPicEle.offsetTop || 0,
                bigPicWidth = smallPicEle.getAttribute("data-width"),
                bigPicHeight = smallPicEle.getAttribute("data-height"),
                smallPicWidth = smallPicEle.clientWidth || 0,
                smallPicHeight = smallPicEle.clientHeight || 0;
            if (bigPicWidth / bigPicHeight >= 1 && bigPicWidth > 2500) {
                bigPicHeight = 2500 * (bigPicHeight / bigPicWidth)
                bigPicWidth = 2500
            } else if (bigPicWidth / bigPicHeight < 1 && bigPicHeight > 2500) {
                bigPicWidth = 2500 * (bigPicWidth / bigPicHeight)
                bigPicHeight = 2500
            }
            oCircle.style.left = x - bannerLeft - circleWidth / 2 + "px";
            oCircle.style.top = y - bannerTop - circleWidth / 2 + "px";
            oCircle.style.backgroundPosition = ((smallPicLeft + bannerLeft - x) * bigPicWidth / smallPicWidth + circleWidth / 2) + "px " + ((smallPicTop + bannerTop - y) * bigPicHeight / smallPicHeight + circleWidth / 2) + "px";
        },
        wheelCircel(event) {
            if ((this.isLogin==0||this.isMem==0)) {
                return false
            }
            let delta = event.wheelDelta || event.detail
            let oCircel = document.getElementById('circleOuter');
            var cirWidth = parseFloat(oCircel.clientWidth);
            var backgroundPosition = getStyle(oCircel, "background-position"),
                bpX = parseFloat(backgroundPosition.split(" ")[0]),
                bpY = parseFloat(backgroundPosition.split(" ")[1]),
                cirLeft = parseFloat(getStyle(oCircel, "left")),
                cirTop = parseFloat(getStyle(oCircel, "top"));
            this.ifShowArray = false
            if (delta > 0) {
                if (cirWidth >= 300) {
                    this.bigMessageShow = true;
                }
                oCircel.style.left = cirLeft - 3 + "px";
                oCircel.style.top = cirTop - 3 + "px";
                oCircel.style.width = cirWidth + 6 + "px";
                oCircel.style.height = cirWidth + 6 + "px";
                oCircel.style.backgroundPosition = (bpX + 3) + "px " + (bpY + 3) + "px";
            } else {
                if (cirWidth >= 36) {
                    oCircel.style.left = cirLeft + 3 + "px";
                    oCircel.style.top = cirTop + 3 + "px";
                    oCircel.style.width = cirWidth - 6 + "px";
                    oCircel.style.height = cirWidth - 6 + "px";
                    oCircel.style.backgroundPosition = (bpX - 3) + "px " + (bpY - 3) + "px";
                }
            }

            function getStyle(element, attr) {
                if (element.currentStyle) {
                    return element.currentStyle[attr];
                } else {
                    return getComputedStyle(element, false)[attr];
                }
            }
        },
        closeTips() {
            this.bigMessageShow = false
        },
        circleShow(event) {
            if ((this.isLogin==0||this.isMem==0)) {
                return false
            }
            let target = event.target
            if (!target.querySelector('img')) {
                return false
            }
            this.showCircle = true;
        },
        circleHide() {
            if ((this.isLogin==0||this.isMem==0)) {
                return false
            }
            this.showCircle = false;
            this.ifShowArray = true
        },
        stopEvent(event) {
            event.stopPropagation()
        },
        xtu(i) {
            this.tuIndex = i
        },
        xtuNext() { //下一张
            var lengths = this.bigPicArray.length;
            if (this.tuIndex < lengths - 1) {
                this.tuIndex++
                if (lengths > this.xianShu) {
                    if (this.tuIndex == this.xianShu - (this.leftShu)) {
                        this.leftShu--
                    }
                }
            } else { //跳回到第一张
                this.tuIndex = 0
                this.leftShu = 0
            }
        },
        xtuPrev() { //上一张
            var lengths = this.bigPicArray.length;
            if (this.tuIndex > 0) {
                this.tuIndex--
                if (lengths > this.xianShu) {
                    if (this.tuIndex <= (this.xianShu + this.leftShu)) {
                        if (this.leftShu < 0) {
                            this.leftShu++
                        }
                    }
                }
            } else { //跳回到最后一张
                this.tuIndex = lengths - 1
                this.leftShu = this.xianShu - lengths
            }
        },
        search2JSON(url) {
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var a = url.indexOf("?")
                var str = url.substr(a);
                str = str.replace('?', '')
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
    }
}
</script>

<style lang="scss" scoped>
//@import "../../../assets/css/share.min.css";
.hdTips {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    text-align: left;
    background-color: rgba(25, 114, 0, 0.8);
    color: #fff;
    font-size: 14px;
    line-height: 30px;
    padding: 0 20px;
    z-index: 1000;

    a {
        color: #fff;
        text-decoration: underline;
    }

    .close {
        background: url(../../../../assets/imgs/icon_close_w.png) no-repeat 0 0;
        width: 12px;
        height: 12px;
        display: inline-block;
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -6px;
        cursor: pointer;
    }
}

#smallOuter {
    width: 100%;
    height: 488px;
    border-radius: 12px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        max-height: 488px;
        max-width: 500px;
        object-fit: contain;
    }
}

#circleOuter {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    width: 200px;
    height: 200px;
    overflow: hidden;
    border: 1px solid #999;
    border-radius: 50%;
    box-shadow: 0px 0px 8px #000;
    background-repeat: no-repeat;
    background-color: #333333;
    opacity: 0;
    cursor: none;
    -moz-user-select: none;
    transition: .2s opacity ease-in-out;
}

#circleOuter.showCircle {
    opacity: 1;
}

.productPic {
    width: 500px;
    // min-height: 650px;

    .productHeader {
        position: relative;

        .vipBtn {
            cursor: pointer;
            position: absolute;
            padding: 6px;
            right: 16px;
            top: 16px;
            z-index: 2;
            background: rgba(0, 0, 0, 0.2);
            border-radius: 25px 25px 25px 25px;
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFF;

            img {
                width: 26px;
                height: 14px;
                vertical-align: sub;
            }
        }
    }

    h2 {
        color: #fff;
        margin-bottom: 18px;
        line-height: 32px;
        font-size: 24px;
        font-weight: bold;
        align-items: center;
    }

    .productFlag {
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        position: relative;
        align-items: center;

        .flag {
            font-size: 0;

            span {
                display: inline-block;
                color: #BFBFBF;
                font-size: 12px;
                padding: 0 4px;
                line-height: 18px;
                border: 1px solid #BFBFBF;
                border-radius: 4px;
                margin-right: 10px;
            }
        }

        .shareBox {
            color: #BFBFBF;
            display: flex;
        }
    }

    .productTips {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .showBig {
            line-height: 28px;
            padding-left: 26px;
            font-size: 14px;
            color: #fff;
            background: url("../../../../assets/imgs/icon_search_w.png") no-repeat left center;
        }

        .liveStatus {
            display: flex;

            a {
                width: 108px;
                height: 28px;
                border: 2px solid #329d15;
                text-align: center;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                transition: .2s all ease-in-out;
            }

            .liveEnd {
                background-color: #eaf5e7;
                color: #329d15;
            }

            .liveEnd:hover {
                color: #fff;
                background-color: #000;
            }

            .liveIng {
                background-color: #329d15;
                color: #fff;

                img {
                    height: 10px;
                    margin-right: 8px;
                }
            }

            .liveIng:hover {
                background-color: #18BD6F;
            }
        }
    }

    .productBigShow {
        height: 488px;
        position: relative;
        overflow: hidden;
        border-radius: 15px;
        .artronIcon{
            position:absolute;
            background: url('../../../../assets/imgs/detail_bg3.png') no-repeat;
            background-size: 102px 27px;
            z-index: 2;
            width: 102px;
            height: 27px;
            left: 14px;
            bottom: 10px;
        }
        .blurImgBox{
            width: 100%;
            height: 100%;
            filter: blur(10px);
            position:absolute;
            top: 0;
            left: 0;
            img{
                width: 100%;
                height: 100%;
                transform: scale(1.2);
            }
        }

        span {
            background-color: rgba(0, 0, 0, 0.65);
            display: block;
            position: absolute;
            padding: 0 20px;
            line-height: 40px;
            color: #FF8F4C;
            border-radius: 20px;
            right: 20px;
            top: 20px;
            z-index: 100;
            cursor: pointer;
        }

        .noBigPic {
            width: 100%;
            height: 100%;
            display: block;
            position: relative;
            background-color: #000000;
            color: #595959;
            font-size: 24px;
            text-align: center;
            line-height: 488px;
        }
    }

}

.gaoqing_img {
    width: 36px;
    margin-right: 8px;
    vertical-align: text-bottom;
}

.vipDt {
    background: rgba(0, 0, 0, 0.2);
    display: block;
    padding: 0 10px;
    line-height: 24px;
    font-size: 14px;
    color: #FFE2BB;
    border-radius: 20px;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 52px;
    z-index: 999;
}

.share0 {
    width: 36px;
    height: 36px;
    cursor: pointer;
    margin: 0 4px;
}

//.icon_weibo{border-radius: 4px;line-height: 20px;border:0;background:#F8646C url("../../../../assets/imgs/icon_weibo.png") no-repeat center;}
//.icon_weibo:before{font-size: 14px;color:#fff;}
//.moreShare{width:36px;height:36px;padding:0px;border:0px;border-radius: 50%;background:#6FBBE7 url("../../../../assets/imgs/icon_add_w.png") no-repeat center;position: relative;}

.sharePop {
    width: 100%;
}

/deep/ .social-share .icon-wechat .wechat-qrcode {
    max-width: auto !important;
}

.swiper-wrapper {
    max-width: 310px;
    overflow: hidden;

    .swiper-wrapper-box {
        white-space: nowrap;
    }
}

.swiperDetail {
    position: absolute;
    bottom: -560px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 378px;
    z-index: 100;
    max-width: 310px;

    .swiper-container {
        min-width: 54px;
        text-align: center;
        position: relative;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .swiper-slide {
        width: 54px !important;
        height: 54px;
        margin: 0 4px;
        display: inline-block;
        cursor: pointer;
        border: 2px solid transparent;
        border-radius: 4px;
        overflow: hidden;
    }

    .swiper-slide-active {
        border-color: #329d15;
    }

    .swiper-button-prev,
    .swiper-button-next {
        width: 24px;
        height: 24px;
        background: rgba(0, 0, 0, .65);
        cursor: pointer;
        position: absolute;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, .65);
        overflow: hidden;
        background-repeat: no-repeat;
        background-position: center;
        top: 15px;
    }

    .swiper-button-prev:after,
    .swiper-button-next:after {
        content: '';
    }

    .swiper-button-next {
        right: -28px;
        background-image: url("../../../../assets/imgs/icon_right_w.png");
    }

    .swiper-button-prev {
        left: -28px;
        background-image: url("../../../../assets/imgs/icon_left_w.png");
    }
}
</style>
